import {
  AssignConfig, getColorDefault,
  deepAssign,
  getTooltipFormatter,
  getToolTipDefaultStyle
} from '@/utils/echarts-option/base'
import { getCssColorVar } from '@/utils/chart-theme-colors'
import { applyEchartsFontToOption, withEchartsTextStyle } from '@/utils/echarts-option/font'
import { cutNumber } from '@/utils/format'

/** series */
export function getSeriesPieOption (config = {} as AssignConfig) {
  const unitString = config.unit ? ` ${config.unit}` : ''
  return {
    type: 'pie',
    /** 全站饼图统一环状尺寸与居中（业务侧勿再重复写） */
    radius: ['40%', '60%'],
    center: ['50%', '50%'],
    itemStyle: {
      borderWidth: 1,
      borderColor: getCssColorVar('--cm-color-card-bg', '#fff'),
      borderRadius: 10,
    },
    data: {
      label: {
        show: true,
        ...withEchartsTextStyle({
          fontSize: 14,
          color: getCssColorVar('--cm-color-text-primary', '#222'),
        }),
        formatter: (params) => {
          const value = params.data.realValue || params.value
          return `${params.name}：${value}${unitString}`
        },
      },
    }
  }
}

/** legend（函数形式：颜色运行时读取，主题切换重绘后生效） */
export function getLegendPieOption () {
  return {
    show: false,
    type: 'scroll',
    left: 'center',
    bottom: 0,
    itemWidth: 12,
    itemHeight: 4,
    itemGap: 16,
    textStyle: withEchartsTextStyle({
      fontSize: 14,
      lineHeight: 4,
      color: getCssColorVar('--cm-color-text-secondary', '#888888'),
    }),
  }
}

export function getTooltipOption (config = {} as AssignConfig) {
  return {
    ...getToolTipDefaultStyle({trigger: 'item'}),
    formatter: (params) => {
      params = JSON.parse(JSON.stringify(params))
      params.value = params.data.realValue || params.value
      return getTooltipFormatter(params, config)
    }
  }
}

export function getPieOption (config = {} as AssignConfig) {
  return {
    color: getColorDefault(),
    series: getSeriesPieOption(config),
    legend: getLegendPieOption(),
    tooltip: getTooltipOption(config),
  }
}

export function getAssignPieOption (option: object, config: AssignConfig = {}) {
  option = formatOption(option, config)
  return applyEchartsFontToOption(
    deepAssign(getPieOption(config), option) as Record<string, unknown>,
  )
}

export function formatOption (option, config: AssignConfig = {}) {
  const series = Array.isArray(option?.series) ? option.series : []
  series.forEach(seriesItem => {
    const data = Array.isArray(seriesItem?.data) ? seriesItem.data : []
    seriesItem.data = data.filter(v => Number(v.value) !== 0)
    const values = seriesItem.data.map(v => +v.value)
    seriesItem.data.forEach(v => {
      v.realValue = v.value
      config.log && (v.value = cutNumber(values, +v.value))
    })
  })
  return option
}
